// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.set-wise-table {
    width: 100%;
    border-collapse: collapse;
}

.set-wise-table th,
.set-wise-table td {
    border: 2px solid #000;
    text-align: center;
    vertical-align: middle;
    padding: 6px;
    font-size: 14px;
}

.set-wise-table thead th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.total-row {
    background-color: #fafafa;
}

.grand-total {
    background-color: #e9ecef;
    font-weight: bold;
    font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/ReportSetWiseTrip.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".set-wise-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.set-wise-table th,\r\n.set-wise-table td {\r\n    border: 2px solid #000;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 6px;\r\n    font-size: 14px;\r\n}\r\n\r\n.set-wise-table thead th {\r\n    background-color: #f2f2f2;\r\n    font-weight: bold;\r\n}\r\n\r\n.total-row {\r\n    background-color: #fafafa;\r\n}\r\n\r\n.grand-total {\r\n    background-color: #e9ecef;\r\n    font-weight: bold;\r\n    font-size: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
